import React, { forwardRef, useEffect } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { getListAPI } from '../../../../services';

const Template = forwardRef(
  (
    {
      value,
      onChange,
      inputValue,
      updateValue,
      valueDebounce,
      label,
      handleKey,
      resource,
      nested,
      fullWidth = true,
      style = {},
      autoFocus = false,
      filters,
      campo = 'nome',
      getOptionSelected = (option, value) => option.id === value.id,
      getOptionLabel = (option) => option?.[campo] || '',
      disabled = false,
      campoPesquisa,
      perPage = 10,
      multiple = false,
      ...rest
    },
    forwardedRef,
  ) => {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);

    const loading = open && options.length === 0;

    async function loadOptions() {
      const filter = { ...filters };
      filter[campoPesquisa || campo] = valueDebounce;

      const response = await getListAPI(
        resource,
        ['id', 'asc'],
        [1, perPage],
        filter,
        nested,
      );

      setOptions(response.data);
    }

    useEffect(() => {
      if (open) loadOptions();
      else setOptions([]);
    }, [open]);

    useEffect(() => {
      if (open) loadOptions();
    }, [valueDebounce]);

    return (
      <Autocomplete
        multiple={multiple}
        style={style}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={multiple ? value || [] : value}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          updateValue(newInputValue);
        }}
        getOptionSelected={getOptionSelected}
        getOptionLabel={getOptionLabel}
        options={options}
        loading={loading}
        fullWidth={fullWidth}
        disabled={disabled}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            margin="normal"
            variant="outlined"
            {...rest}
            {...params}
            label={label}
            fullWidth
            inputRef={forwardedRef}
            onKeyDown={(e) => {
              handleKey(e.keyCode, e.key);
            }}
            autoFocus={autoFocus}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    );
  },
);
export default Template;
